(function(){
    'use strict';

    angular
    .module('appback')
    .controller('AppController', AppController)
 
    AppController.$inject = ["$http","$timeout", "$log", "$document","$sce"];
              
    function AppController($http,$timeout, $log, $document,$sce)
    {                         
        var vm = this;
        
    }
  
})();